import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import React from 'react';
import CommitStatus from './CommitStatus';
export default class CommitStatusProcessing extends CommitStatus {
    renderLoading(isPullRequest, percentage) {
        const reportsLinkClasses = [
            'reports__link__jumbotron-container',
            'reports__link__jumbotron-container--processing',
            'reports__link__jumbotron-container--processing-percentage',
        ];
        return _jsx("div", { className: clsx('commit-status', isPullRequest && 'commit-status--pull-request'), children: _jsx("div", { className: clsx(reportsLinkClasses), style: { '--processing-percentage': percentage + '%' }, children: _jsx("div", { className: "jumbotron reports__link__jumbotron reports__link__jumbotron--processing" }) }) });
    }
}
